import React, { useEffect, useState } from 'react';
import styles from './Notifications.module.css';
import { useNotifications } from "../../utils/NotificationContext/NotificationContext";
import NotificationCard from './../NotificationCard/NotificationCard';
import CompactNavbar from './../CompactNavbar/CompactNavbar';
import { useAuth } from "../../utils/AuthContext/authcontext";
import ContactSidebar from './../ContactSidebar/ContactSidebar';
import { useTranslation } from 'react-i18next';
import Button from '../ui/Button';

export default function Notifications() {
  const { t } = useTranslation();
  const [isContactOpen, setContactOpen] = useState(false);
  const {user, logout, markAllNotificationsAsRead} = useAuth();
  const { notifications } = useNotifications();

  const mlogout = () => {
  }

  const handleMarkAll = () => {
    markAllNotificationsAsRead(user.uid);
  };

  return (
    <>
	<div className={styles.header}>
		<CompactNavbar shownow={false} modal={true} scrollY={0} openContact={() => setContactOpen(true)}  openLogin={(user) => {user != null ? logout(true) : mlogout()}}/>
	</div>
    <div className={styles.container}>
      <h1 className={styles.title}>{t('notifications.title')}</h1>
      
	  {notifications.length > 0 ? <Button onClick={handleMarkAll} className={styles.markAllBtn}>
		{t('notifications.markallread')}
      </Button> : <> </>}
	  
      {notifications.length === 0 ? (
        <div className={styles.empty}>You have no notifications.</div>
      ) : (
        notifications.map(n => (
          <NotificationCard key={n.id} notification={n} />
        ))
      )}
    </div>
	<ContactSidebar isOpen={isContactOpen} onClose={() => setContactOpen(false)} />
	</>
  );
}
